<script setup lang="ts">
import { ref, computed } from 'vue';
import { useAuthStore } from '@/stores/auth';

const auth = useAuthStore();

// Show only for logged-in, unverified accounts, and only until dismissed
// this session.
const dismissed = ref(false);
const show = computed(() =>
  auth.isAuthenticated && auth.user && !auth.user.emailVerified && !dismissed.value,
);

const sending = ref(false);
const sent = ref(false);
const error = ref<string | null>(null);

async function resend() {
  error.value = null;
  sending.value = true;
  try {
    await auth.resendVerification();
    sent.value = true;
  } catch {
    error.value = 'Versturen mislukt. Probeer het later opnieuw.';
  } finally {
    sending.value = false;
  }
}
</script>

<template>
  <v-alert
    v-if="show"
    type="warning"
    variant="tonal"
    density="compact"
    closable
    class="verify-banner"
    @click:close="dismissed = true"
  >
    <template v-if="!sent">
      Bevestig je e-mailadres om je account volledig te activeren.
      <a href="#" class="text-primary font-weight-medium" @click.prevent="resend">
        {{ sending ? 'Versturen…' : 'Verstuur opnieuw' }}
      </a>
      <span v-if="error" class="d-block text-error mt-1">{{ error }}</span>
    </template>
    <template v-else>
      Verificatiemail verstuurd! Check je inbox (en spamfolder).
    </template>
  </v-alert>
</template>

<style scoped>
.verify-banner {
  position: sticky;
  top: 0;
  z-index: 5;
  margin: 8px;
  border-radius: 12px;
}
</style>
